import {
  Box,
  List,
  ListItem,
  Snackbar,
  Typography,
} from '@mui/material';
import styled from '@mui/material/styles/styled';

// About Page container styles =================================================

export const ContainerSx = styled(Box)``;

export const InnerSx = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 50px 20%;
`;

// Heading styles ==============================================================

export const HeadingSx = styled(Typography)`
  color: black;
  font-weight: bold;
  margin: 35px 5px;
`;
HeadingSx.defaultProps = {
  variant: 'h3',
};

// Summary styles ==============================================================

export const SummaryTextSx = styled(Typography)`
  margin-top: 15px;
`;
SummaryTextSx.defaultProps = {
  variant: 'body1',
};

export const SummaryListSx = styled(List)``;

export const SummaryListItemSx = styled(ListItem)`
  list-style-type: circle;
`;

export const SummaryListItemTextSx = styled(Typography)``;
SummaryTextSx.defaultProps = {
  variant: 'body1',
};

// About Page group styles =====================================================

export const CommitteeGroupSx = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 80px;
  justify-content: space-around;
`;

export const MemberGroupSx = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 60px;
  justify-content: space-around;
`;

// Image styling

export const MemberImageWrapperSx = styled('div')`
  aspectRatio: '1 / 1' 
  width: 225px;
  height: 225px;
  overflow: hidden;      /* crop anything outside the square */
  border-radius: 12px;   /* optional rounded corners */
  flex-shrink: 0;        /* prevent flexbox from squishing */
  
  @media (max-width: 1024px) {
    width: 160px;
    height: 160px;
  }

  @media (max-width: 768px) {
    width: 130px;
    height: 130px;
  }

  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
  }
`;

export const MemberImageSx = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills the square perfectly */
  display: block;
`;

export const MemberCardSx = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;  /* centers image + text horizontally */
  text-align: center;   /* ensures text is centered under image */
`;

// About Page misc component styles ===========================================

export const SnackbarSx = styled(Snackbar)``;
